import { bindActionCreators } from 'redux'
import { checkSession } from '../../actions'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import React, { useEffect, useState } from 'react'
import PageSizeFilter from '../common/page_size_filter'
import { enableSelfieCheckFilter } from '../../actions/selfie-check'
import { getAgentBatch, putAgentBatch, putAgentBatchClearMessage } from '../../actions/agent-batch'
import Spinner3Bounce from '../spinner_3_bounce'
import { closeLightbox, openLightbox } from '../../actions/lightbox'
import { Alert, Button } from 'react-bootstrap'
import Lightbox from 'react-image-lightbox'
import NoData from '../visualization_components/noData'
import './styles.css'
import Sticky from 'react-stickynode'

const SelfieCheckComponent = ({
  selfieCheckFilter,
  enableSelfieCheckFilter,
  data,
  getAgentBatch,
  putAgentBatch,
  isFetching,
  errorMessage,
  openLightbox,
  closeLightbox,
  isLightboxOpen,
  photoSrc,
  successMessage,
  putAgentBatchClearMessage,
  isSubmitting,
  message,
}) => {
  const [selected, setSelected] = useState({})

  const updatePageSizeFilter = ({ pageSize }) => {
    enableSelfieCheckFilter({ ...selfieCheckFilter, pageSize })
  }

  const onSubmit = async () => {
    const transactions = Object.keys(selected).map((i) => ({
      transaction_id: i,
      receipt_handle: selected[i].receipt_handle,
      classification: selected[i].classification,
    }))

    await putAgentBatch({ transactions })
    getAgentBatch(selfieCheckFilter.pageSize)
    setSelected({})
  }
  useEffect(() => {
    // enableSelfieCheckFilter(defaultFilter)
    if (selfieCheckFilter.pageSize) {
      getAgentBatch(selfieCheckFilter.pageSize)
    }
  }, [selfieCheckFilter])

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => putAgentBatchClearMessage(), 5000)
    }
  }, [successMessage])

  const onSelect = (value, item) =>
    setSelected({
      ...selected,
      [item.transaction_id]: { receipt_handle: item.receipt_handle, classification: value },
    })

  return (
    <div>
      <div className='row'>
        <div className='col-xs-6 col-sm-2'>
          <PageSizeFilter updateFilter={updatePageSizeFilter} filter={selfieCheckFilter.pageSize} />
        </div>
        <div className='col-xs-6 col-sm-2' />
      </div>
      {successMessage && (
        <Alert className='m-b-sm m-t-sm animated fadeIn' bsStyle='success' style={{ margin: '1rem' }}>
          {successMessage}
        </Alert>
      )}

      <div>
        <>
          {isFetching && (
            <div className='text-center grid-spinner-mt-60'>
              <Spinner3Bounce isActive />
            </div>
          )}
        </>
        <>
          {!isFetching && (
            <>
              {!errorMessage && !message && (
                <div className={'m-b-sm m-t-sm'}>
                  {data && (
                    <>
                      {data.length === 0 && <NoData />}
                      {data.length > 0 && (
                        <>
                          <div className='alert alert-info animated fadeIn' style={{ margin: '1rem' }}>
                            Records need to be completed in ten minutes. Please submit updates less than ten minutes
                            after batch is pulled.
                          </div>
                          <div className={'selfie-check-table'}>
                            <Sticky enabled={true} top={0}>
                              <div className={'selfie-check-table-header'}>
                                <div>Transaction</div>
                                <div>Selfie</div>
                                <div>DUI Image</div>
                                <div>Real person</div>
                                <div>Decline photo of DUI</div>
                                <div>Decline photo of Photo</div>
                                <div>Decline not same person</div>
                                <div>No change</div>
                              </div>
                            </Sticky>

                            {data.map((item, i) => (
                              <div key={i} className={'selfie-check-table-row'}>
                                <div className={'selfie-check-table-column'}>
                                  <Link to={`/tx-details/${item.transaction_id}`} target={'_blank'}>
                                    View Transaction
                                  </Link>
                                </div>
                                <div className={'selfie-check-table-column'}>
                                  <img
                                    src={item.selfie}
                                    alt='Selfie'
                                    style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                    onClick={() => openLightbox(item.selfie)}
                                  />
                                </div>
                                <div className={'selfie-check-table-column'}>
                                  <img
                                    src={item.dui_image}
                                    alt='DUI Image'
                                    style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
                                    onClick={() => openLightbox(item.dui_image)}
                                  />
                                </div>
                                <div className={'selfie-check-table-column'}>
                                  <input
                                    type='radio'
                                    name={item.transaction_id}
                                    title='Real person'
                                    onChange={(event) => onSelect('real person', item)}
                                    checked={
                                      !!(
                                        selected[item.transaction_id] &&
                                        selected[item.transaction_id].classification === 'real person'
                                      )
                                    }
                                  />
                                </div>
                                <div className={'selfie-check-table-column'}>
                                  <input
                                    type='radio'
                                    name={item.transaction_id}
                                    onChange={(event) => onSelect('decline photo of DUI', item)}
                                    title='Decline photo of DUI'
                                    checked={
                                      !!(
                                        selected[item.transaction_id] &&
                                        selected[item.transaction_id].classification === 'decline photo of DUI'
                                      )
                                    }
                                  />
                                </div>
                                <div className={'selfie-check-table-column'}>
                                  <input
                                    type='radio'
                                    name={item.transaction_id}
                                    onChange={(event) => onSelect('decline photo of photo', item)}
                                    title='Decline photo of Photo'
                                    checked={
                                      !!(
                                        selected[item.transaction_id] &&
                                        selected[item.transaction_id].classification === 'decline photo of photo'
                                      )
                                    }
                                  />
                                </div>
                                <div className={'selfie-check-table-column'}>
                                  <input
                                    type='radio'
                                    name={item.transaction_id}
                                    onChange={(event) => onSelect('decline not same person', item)}
                                    title='Decline not same person'
                                    checked={
                                      !!(
                                        selected[item.transaction_id] &&
                                        selected[item.transaction_id].classification === 'decline not same person'
                                      )
                                    }
                                  />
                                </div>
                                <div className={'selfie-check-table-column'}>
                                  <input
                                    type='radio'
                                    name={item.transaction_id}
                                    onChange={(event) => onSelect('do_nothing', item)}
                                    title='No change'
                                    checked={
                                      !!(
                                        selected[item.transaction_id] &&
                                        selected[item.transaction_id].classification === 'do_nothing'
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </>
                  )}

                  <div style={{ display: 'flex', justifyContent: 'center', margin: '0.5rem' }}>
                    <div>
                      <Button
                        bsStyle='primary'
                        onClick={() => onSubmit()}
                        disabled={Object.keys(selected).length === 0 || isSubmitting}
                      >
                        Submit
                      </Button>
                      &nbsp;
                      <Button
                        bsStyle='danger'
                        onClick={() => setSelected({})}
                        disabled={Object.keys(selected).length === 0 || isSubmitting}
                      >
                        Reset Radio Buttons
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {message && (
                <>
                  <div className='alert alert-info animated fadeIn' style={{ margin: '1rem' }}>
                    {message}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', margin: '0.5rem' }}>
                    <Button bsStyle='primary' onClick={() => getAgentBatch(selfieCheckFilter.pageSize)}>
                      Fetch data
                    </Button>
                  </div>
                </>
              )}
              {errorMessage && (
                <>
                  <div className='alert alert-danger animated fadeIn' style={{ margin: '1rem' }}>
                    {errorMessage}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', margin: '0.5rem' }}>
                    <Button bsStyle='primary' onClick={() => getAgentBatch(selfieCheckFilter.pageSize)}>
                      Fetch data
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
        </>
      </div>
      {isLightboxOpen && <Lightbox mainSrc={photoSrc} onCloseRequest={() => closeLightbox()} />}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  selfieCheckFilter: state.selfieCheckFilter.selfieCheckFilter,
  data: state.getAgentBatch.data,
  message: state.getAgentBatch.message,
  successMessage: state.putAgentBatch.results,
  isFetching: state.getAgentBatch.isFetching,
  isSubmitting: state.putAgentBatch.isFetching,
  errorMessage: state.getAgentBatch.errorMessage,
  isLightboxOpen: state.lightbox.isLightboxOpen,
  photoSrc: state.lightbox.photoSrc,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkSession,
      enableSelfieCheckFilter,
      getAgentBatch,
      putAgentBatch,
      openLightbox,
      closeLightbox,
      putAgentBatchClearMessage,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelfieCheckComponent))
